var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAC24\\uB7EC\\uB9AC\\uD615",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.494,
    height: 18.494,
    viewBox: "0 0 18.494 18.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_30",
    "data-name": "\\uC0AC\\uAC01\\uD615 30",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H7.926V7.926H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.28401517868042 5.28401517868042 L 5.28401517868042 2.64200758934021 L 2.64200758934021 2.64200758934021 L 2.64200758934021 5.28401517868042 L 5.28401517868042 5.28401517868042 M 7.926022529602051 7.926022529602051 L -5.866435313839813e-16 7.926022529602051 L -5.866435313839813e-16 -5.866435313839813e-16 L 7.926022529602051 -5.866435313839813e-16 L 7.926022529602051 7.926022529602051 Z",
    stroke: "none",
    fill: "#1d333e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_31",
    "data-name": "\\uC0AC\\uAC01\\uD615 31",
    transform: "translate(10.568)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H7.926V7.926H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.28401517868042 5.28401517868042 L 5.28401517868042 2.64200758934021 L 2.64200758934021 2.64200758934021 L 2.64200758934021 5.28401517868042 L 5.28401517868042 5.28401517868042 M 7.926022529602051 7.926022529602051 L -5.866435313839813e-16 7.926022529602051 L -5.866435313839813e-16 -5.866435313839813e-16 L 7.926022529602051 -5.866435313839813e-16 L 7.926022529602051 7.926022529602051 Z",
    stroke: "none",
    fill: "#1d333e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_32",
    "data-name": "\\uC0AC\\uAC01\\uD615 32",
    transform: "translate(0 10.568)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H7.926V7.926H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.28401517868042 5.28401517868042 L 5.28401517868042 2.64200758934021 L 2.64200758934021 2.64200758934021 L 2.64200758934021 5.28401517868042 L 5.28401517868042 5.28401517868042 M 7.926022529602051 7.926022529602051 L -5.866435313839813e-16 7.926022529602051 L -5.866435313839813e-16 -5.866435313839813e-16 L 7.926022529602051 -5.866435313839813e-16 L 7.926022529602051 7.926022529602051 Z",
    stroke: "none",
    fill: "#1d333e"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_33",
    "data-name": "\\uC0AC\\uAC01\\uD615 33",
    transform: "translate(10.568 10.568)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H7.926V7.926H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.28401517868042 5.28401517868042 L 5.28401517868042 2.64200758934021 L 2.64200758934021 2.64200758934021 L 2.64200758934021 5.28401517868042 L 5.28401517868042 5.28401517868042 M 7.926022529602051 7.926022529602051 L -5.866435313839813e-16 7.926022529602051 L -5.866435313839813e-16 -5.866435313839813e-16 L 7.926022529602051 -5.866435313839813e-16 L 7.926022529602051 7.926022529602051 Z",
    stroke: "none",
    fill: "#1d333e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.be3cf7a018e5c519b13cc2173dad656a.svg";
export { ForwardRef as ReactComponent };